<template>
  <div>
    <div class="flex items-center justify-end" style="margin-right: 10%;">
      <p class="text-amplitude mr-4 font-semibold cursor-pointer" @click="handleData(basic)">  <i class="el-icon-refresh"></i> Reload Graph</p>
      <p :class="show_by === 'trx' && 'text-amplitude'" class="ns-sf--head-sel text-sm uppercase cursor-pointer font-semibold" @click="handleData('trx')">{{selected_forecast_view == 'sales' ? 'Transactions' : 'Labour Hrs'}}</p>
      <p class="ns-sf--head-sel mx-2">|</p>
      <p :class="show_by === 'sales' && 'text-amplitude'" class="ns-sf--head-sel text-sm uppercase cursor-pointer font-semibold" @click="handleData('sales')">{{selected_forecast_view == 'sales' ? 'Sales' : 'Labour Cost'}}</p>
    </div>
    <div ref="chart" class="chart-container"></div>
  </div>
</template>

<script>
import echarts from 'echarts';
import { mapState } from "vuex";
import { EventBus } from '../../../eventBus';
export default {
  name: "SalesForecastChart",
  props: {
    graphData: {
      type: Array,
      required: true
    },
    isLoading: {
      type: Boolean,
      default: true
    },
    graphView: {
      type: String,
      default: 'week'
    }
  },
  data() {
    return {
      chart: null,
      xAxisData: [],
      projectedData: [],
      actualData: [],
      show_by: 'sales',
      data_point_one: 'Projected Sales',
      data_point_two: 'Actual Sales',
      basic: 'sales'
    };
  },
  computed: {
    ...mapState("salesForecastStoreV2", ['selected_forecast_view']),
    dataKeys() {
      if(this.selected_forecast_view === 'sales') {
        return this.show_by === 'trx' ? {actual: 'curr_actual_transactions', forecast: 'curr_forecast_transactions', label_one: 'Actual Transactions', label_two: 'Projected Transactions'} : {actual: 'curr_actual_sales', forecast: 'curr_forecast_sales', label_one: 'Actual Sales', label_two: 'Projected Sales'};
      } else {
        return this.show_by === 'trx' ? {actual: 'curr_actual_lab_hrs', forecast: 'curr_forecast_lab_hrs', label_one: 'Actual Labour Hrs', label_two: 'Projected Labour Hrs'} : {actual: 'curr_actual_lab_cost', forecast: 'curr_forecast_lab_cost', label_one: 'Actual Labour Cost', label_two: 'Projected Labour Cost'};
      }
    }
  },
  watch: {
    graphData: {
      deep: true,
      handler(newData) {
        this.chart.showLoading();
        this.processData(this.graphData, {actual: this.dataKeys.actual, forecast: this.dataKeys.forecast});
      }
    },
    // dataKeys: {
    //   deep: true,
    //   handler(newData) {
    //     this.chart.showLoading();
    //     this.processData(this.graphData, {actual: this.dataKeys.actual, forecast: this.dataKeys.forecast});
    //   }
    // }
  },
  mounted() {
    this.chart = echarts.init(this.$refs.chart);
    this.renderChart();
    EventBus.$on('changeBasic', (basic) => {
      this.basic = basic;
       if(basic === 'lab_hrs') {
         this.handleData('trx');
       }
    });
  },
  methods: {
    processData(data, selected_key = {actual:'curr_actual_sales', forecast:'curr_forecast_sales'}) {
      console.log(data, selected_key)
      this.xAxisData = [];
      this.projectedData = [];
      this.actualData = [];
      data.forEach(dayData => {
        this.xAxisData.push(dayData.forecast_week);
        this.projectedData.push(dayData[selected_key.forecast] === '-' ? 0 : dayData[selected_key.forecast]);
        this.actualData.push(dayData[selected_key.actual] === '-' ? 0 : dayData[selected_key.actual]);
      });

      setTimeout(() => {
        this.renderChart();
        this.chart.hideLoading();
      }, 1000);
    },
    handleData(data) {
      this.show_by = data;
      let legendData, yAxisName;
      let seriesData = [];
      if(data === 'trx') {
        this.data_point_one = 'Projected Transactions';
        this.data_point_two = 'Actual Transactions';
      } else {
        this.data_point_one = 'Projected Sales';
        this.data_point_two = 'Actual Sales';
      }
      this.processData(this.graphData, {actual: this.dataKeys.actual, forecast: this.dataKeys.forecast});
      this.renderChart();
    },
    renderChart() {
      this.chart.setOption({
        tooltip: {
          trigger: 'axis'
        },
        legend: {
          data: [this.data_point_one, this.data_point_two]
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: this.xAxisData,
          axisLabel: {
            rotate: this.graphView === 'hour' ? 45 : 0
          }
        },
        yAxis: [
					{
						type: "value"
					},
					{
						type: "value",
						axisLine: {
							show: true,
							lineStyle: {
								color: "black"
							}
						}
					}
				],
        series: [
          {
            name: this.dataKeys.label_two,
            type: 'line',
            data: this.projectedData,
            color: "#156082"
          },
          {
            name: this.dataKeys.label_one,
            type: 'line',
            data: this.actualData,
            color: "#D26300"
          }
        ]
      });
    }
  }
};
</script>

<style>
.chart-container {
  width: 100%;
  height: 400px;
}
</style>
